<template>
  <div class="top__background__area">
    <div class="flames__area">
      <img class="flame" src="/assets/img/common/flame.svg">    
      <img class="flame" src="/assets/img/common/flame.svg">
      <img class="flame" src="/assets/img/common/flame.svg">
      <img class="flame" src="/assets/img/common/flame.svg">
    </div>
    <video preload="true" playsinline="" autoplay="" muted="" loop="" id="vid1" v-bind:class="{'bg_video':bgVideo}" v-bind:style="bgVideoStyles" v-on:mousemove="bgParallax" poster="/site/assets/videos/home_poster.jpg">
        <source v-bind:src="videoSrcMp4">
        <source v-bind:src="videoSrcWebm">
    </video>
  </div>
</template>
<script>
export default {
  name: 'Background',
  // 親から受け取るデータ
  props: {
    msg: String,
  },
  data () {
    return {
      bgVideo: true,
      // top動画URL
      videoSrcMp4: '',
      videoSrcWebm:'',
      // 背景動画動的スタイル
      bgVideoStyles: {
        // 幅視差移動距離
        marginLeft: '0px',
        // 高さ視差移動距離
        marginTop: '0px',
      },
    }
  },
  created: function() {
    /**
     * 読み込み動画切り分け
     * モバイルサイズとそれ以外
     */
    if (navigator.userAgent.indexOf('iPhone') > 0 ||
      navigator.userAgent.indexOf('Android') > 0) {
        this.videoSrcMp4 = '/assets/video/mobile_top_mv.mp4';
        this.videoSrcWebm = '/assets/video/mobile_top_mv.webm';
    } else {
      this.videoSrcMp4 = '/assets/video/yamada_top_mv.mp4';
      this.videoSrcWebm = '/assets/video/yamada_top_mv.webm';
    }
  },
  methods: {
    /**
     * TOPのmousemoveイベント
     */
    bgParallax(event){
      // ブラウザ幅
      var ww = window.innerWidth;
      // ブラウザ高さ
      var wh = window.innerHeight;
      var halfWidth = ww/2;
      var halfHeight = wh/1.5;
      // 背景余白
      var pm = 20;
      // 幅視差効果距離
      var marginWidth = 0;
      // 高さ視差効果距離
      var marginHeight = 0;
      // 中心から端までの距離を、余分に大きくとった背景画像の分（ここでは20÷2=10px）に割り当てる
      marginWidth = ( event.clientX - halfWidth ) / halfWidth * ( pm / 2 ); // 0.0 ~ 10.0
      marginHeight = ( event.clientY - halfHeight ) / halfHeight * ( pm / 2 );
      this.bgVideoStyles.marginLeft = marginWidth + 'px';
      this.bgVideoStyles.marginTop = marginHeight + 'px';
    }
  },
}
</script>
<style lang="scss" scoped>
.flame {
    position: absolute;
    width: 16%;
}
.flame:nth-child(1) {
    top: 19.5%;
    right: 17%;
}
.flame:nth-child(2) {
  top: 19.5%;
  left: 17%;
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1); 
}
.flame:nth-child(3) {
    bottom: 15.5%;
    right: 17%;
    -webkit-transform: scale(1, -1);
            transform: scale(1, -1);
}
.flame:nth-child(4) {
    bottom: 15.5%;
    left: 17%;
    -webkit-transform: scale(-1, -1);
            transform: scale(-1, -1);
}
.bg_video {
  position: fixed;
  height: calc(100vh - 3vw);
  min-height: calc(100vh - 3vw);
  z-index: -10;
  left: 50%;
  transform: translateX(-50%);
  source {
    width: fit-content;
  }
}
_::-webkit-full-page-media, _:future, :root .bg_video {
  width: fit-content;
}
.top__background__area {
  padding-top: 15vw;
}
// PC
@media screen and (min-width: 768px) {
  .flame {
    width: 8%;
  }
  .top__background__area {
    padding-top: 45px;
  }
}
@media screen and (min-width: 1287px) {
  .top__background__area {
    padding-top: 3.5vw;
  }  
}
@media screen and (min-width: 1572px) {
  .top__background__area {
    padding-top: 55px;
  }    
}
</style>